import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  LogDTO,
  LogList,
  SummaryLogDTO,
  SummaryLogItem,
} from "../../types/log";
import logApi from "../api/LogApi";

interface LogState {
  newLogList?: LogList;
  summaryLogList?: SummaryLogItem[];
}
// # initial state
const initialState: LogState = { newLogList: undefined };
export const trunkNewLogList = createAsyncThunk(
  "log/new/list",
  async (logDTO: LogDTO) => {
    return await logApi.newLogList(logDTO);
  }
);
export const trunkGetSummaryLogList = createAsyncThunk(
  "log/summary",
  async (logDTO: SummaryLogDTO) => {
    return await logApi.getSummaryLogList(logDTO);
  }
);
export const trunkGetLogDetail = createAsyncThunk(
  "log/detail",
  async (req: { logIdList: string[] }) => {
    return await logApi.getLogDetail(req);
  }
);

const logSlice = createSlice({
  name: "log",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      trunkNewLogList.fulfilled,
      (state, { payload: newLogList }) => {
        if (newLogList.logId === undefined || newLogList.logId === null) {
          state.newLogList = {
            ...newLogList,
            logResults: newLogList.logResults?.map((item) => {
              return { ...item, children: [] };
            }),
          };
        } else if (
          state.newLogList &&
          newLogList.lastLogId !== "" &&
          newLogList.lastLogId !== newLogList.logId &&
          (state.newLogList.lastLogId ||
            state.newLogList.lastLogId === newLogList.logId)
        ) {
          state.newLogList.logId = newLogList.logId;
          state.newLogList.lastLogId = newLogList.lastLogId;
          state.newLogList.logResults = state.newLogList.logResults.concat(
            newLogList.logResults.map((item) => {
              return { ...item, children: [] };
            })
          );
        }
      }
    );
    builder.addCase(
      trunkGetSummaryLogList.fulfilled,
      (state, { payload: newLogList }) => {
        state.summaryLogList = newLogList;
      }
    );
  },
});
export const logAction = logSlice.actions;

export default logSlice.reducer;
